import Head from './../components/Head';
import dayjs from 'dayjs';
import { Empty } from 'zhs-components';
import LiveIcon from '@/pages/components/liveIcon';
export default {
  created() {
    this.getTrainType();
    this.getTrainSetting();
    this.getTrainPageList();
    this.getOperationModel();
  },

  components: {
    Head,
    Empty,
    LiveIcon
  },

  data() {
    return {
      Enlist: '暂未开始报名',
      menuId: this.$utils.getUrlParams('menuId'),
      // name: this.$utils.getUrlParams('name'),
      trainTypeList: [],
      trainStatusList: [{
        name: '全部',
        id: null
      }],
      pageInfo: {
        pageSize: 12,
        pageNum: 1,
        total: 0
      },
      status_id: null,
      classify_id: null,
      trainKeyWord: '',
      trainPageList: [],
      OperationModel: {},
      menuInfo: {},
      trainType: false,
      trainStatus: false
    };
  },

  methods: {
    // 类型
    async getTrainType() {
      const trainTypeList = await this.$http.getTrainType({
        menu_id: this.menuId
      });
      var arr = [{
        id: null,
        name: '全部',
        sort: 0
      }];
      this.trainTypeList = arr.concat(trainTypeList);
    },

    // 状态
    async getTrainSetting() {
      const trainSetting = await this.$http.getTrainSetting({
        business_type: 6,
        menu_id: this.menuId
      });
      this.trainType = trainSetting[0].value_str.indexOf('1') > -1 ? true : false;
      this.trainStatus = trainSetting[0].value_str.indexOf('2') > -1 ? true : false;

      if (trainSetting[1].value_str.indexOf('1') > -1) {
        this.trainStatusList.push({
          name: '正在进行',
          id: 1
        });
      }

      if (trainSetting[1].value_str.indexOf('2') > -1) {
        this.trainStatusList.push({
          name: '即将开始',
          id: 2
        });
      }

      if (trainSetting[1].value_str.indexOf('3') > -1) {
        this.trainStatusList.push({
          name: '已结束',
          id: 3
        });
      }
    },

    // 切换类型和状态
    choose(val, num) {
      if (num == 1) {
        this.classify_id = val;
      } else {
        this.status_id = val;
      }

      this.getTrainPageList();
    },

    // 培训列表
    async getTrainPageList() {
      let trainPageList = await this.$http.getTrainPageList({
        menu_id: this.menuId,
        classify_id: this.classify_id,
        status: this.status_id,
        keyWord: this.trainKeyWord,
        '_pageable.page': this.pageInfo.pageNum - 1,
        '_pageable.size': this.pageInfo.pageSize
      });
      this.trainPageList = trainPageList.content;
      this.pageInfo.total = Number(trainPageList.totalElements);
      console.log(this.pageInfo.total, trainPageList, '列表');
    },

    async getOperationModel() {
      let OperationModel = await this.$http.getOperationModel({
        menu_id: this.menuId
      });
      this.OperationModel = OperationModel;
      console.log(OperationModel, '列表1111');
    },

    // 切换分页
    handleCurrentChange(current) {
      this.pageInfo.pageNum = current;
      this.getTrainPageList();
    },

    // 获取新闻详情
    // 搜索
    handleSearch(newsTypeId = '') {
      this.pageInfo.pageNum = 1;
      this.getTrainPageList();
    },

    // 关键字高亮
    // kewordFilter(value) {
    //   if (!value) return ''
    //   if (!this.newsName) return value
    //   let reg = new RegExp(this.newsName, 'g')
    //   return value.replace(reg, `<span class="theme-color">${this.newsName}</span>`)
    // },
    // 点击卡片进去详情页
    goTrainDetails(val) {
      window.location.href = `/trainDetails.html?termId=${val.termId}&trainingId=${val.trainingId}&menuId=${this.menuId}&name=${this.menuInfo.nav_name}`; // if(val.applyStatus == 1){
      //   window.location.href = `/trainDetail.html?termId=${val.termId}&trainingId=${val.trainingId}&menuId=${this.menuId}&name=${this.menuInfo.nav_name}`
      // }
    }

  }
};